import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
  {
    t: "Wybierasz dostęp",
    d: "Nauczycielski, właścicielski albo „Chcę mieć wszystko”. Jedna decyzja, dopasowana do Twojej roli.",
  },
  {
    t: "Otrzymujesz dostęp do biblioteki",
    d: "Kursy, szkolenia, kursoksiążki, e-booki i narzędzia w jednym miejscu, na platformie Luizy.",
  },
  {
    t: "Korzystasz wtedy, kiedy naprawdę ich potrzebujesz",
    d: "Nie musisz „przerobić wszystkiego”. To profesjonalna biblioteka, do której wracasz przez cały rok.",
  },
];

export const HowItWorks = () => (
  <section data-testid="how-it-works-section" className="bg-ink py-20 text-white sm:py-28">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <Eyebrow dark>Jak działa abonament</Eyebrow>
          <h2 className="font-display mt-5 text-4xl font-medium leading-[1.02] tracking-[-0.02em] sm:text-5xl">
            Trzy kroki. <br className="hidden sm:block" />
            Zero komplikacji.
          </h2>
        </Reveal>
        <ol className="lg:col-span-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.08}>
              <li className="grid grid-cols-[56px_1fr] gap-5 border-t border-white/15 py-8 sm:grid-cols-[96px_1fr] sm:py-10">
                <span className="font-display text-4xl leading-none text-red sm:text-5xl">0{i + 1}</span>
                <div>
                  <h3 className="font-display text-2xl font-medium leading-tight sm:text-3xl">{s.t}</h3>
                  <p className="mt-3 max-w-[58ch] text-[15px] leading-relaxed text-white/65 sm:text-base">{s.d}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
